import { createSlice } from "@reduxjs/toolkit";


export const commentaireSlice = createSlice({
    name: 'commentaire',
    initialState:{},
    reducers: { // 
       
        setCommentaire: (currentState, action) => {
            return (action.payload);
        },
        
       
    }
});

